import React, { useState, useEffect } from "react";
import axios from "axios";
import { Check, Clock, X, Phone } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const STATUS_CFG = {
  pending: { label: "Ожидает", color: "#f59e0b", bg: "#fffbeb", border: "#fcd34d" },
  confirmed: { label: "Подтверждена", color: "#10b981", bg: "#f0fdf4", border: "#86efac" },
  done: { label: "Выполнена", color: "#6b7280", bg: "#f9fafb", border: "#e5e7eb" },
  cancelled: { label: "Отменена", color: "#ef4444", bg: "#fef2f2", border: "#fca5a5" },
};

export default function AdminAppointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = () => {
    setLoading(true);
    axios.get(`${API}/appointments`, { withCredentials: true }).then(r => setAppointments(r.data)).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      const res = await axios.put(`${API}/appointments/${id}`, { status }, { withCredentials: true });
      // Open pre-filled WhatsApp link for the manager when an appointment is confirmed
      if (status === "confirmed" && res.data?.whatsapp_link) {
        window.open(res.data.whatsapp_link, "_blank", "noopener");
      }
    } catch (e) {
      alert(e?.response?.data?.detail || "Ошибка обновления");
    }
    load();
  };

  const filtered = filter === "all" ? appointments : appointments.filter(a => a.status === filter);

  return (
    <div>
      {/* Filter */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "20px", flexWrap: "wrap" }}>
        {[["all", "Все"], ["pending", "Ожидает"], ["confirmed", "Подтверждена"], ["done", "Выполнена"], ["cancelled", "Отменена"]].map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)}
            style={{ padding: "8px 16px", borderRadius: "20px", border: `1px solid ${v === filter ? "#C5A059" : "#e5e7eb"}`, background: v === filter ? "rgba(197,160,89,0.1)" : "white", color: v === filter ? "#C5A059" : "#6b7280", fontFamily: "Manrope", fontSize: "12px", cursor: "pointer", fontWeight: v === filter ? 700 : 400 }}>
            {l} {v !== "all" && `(${appointments.filter(a => a.status === v).length})`}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: "40px", color: "#888", fontFamily: "Manrope" }}>Загрузка...</div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: "center", padding: "60px", color: "#888", fontFamily: "Manrope" }}>Записи не найдены</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {filtered.map(a => {
            const sc = STATUS_CFG[a.status] || STATUS_CFG.pending;
            return (
              <div key={a.id} data-testid={`appointment-${a.id}`} style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "18px 20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "12px" }}>
                  <div style={{ flex: 1, minWidth: "200px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                      <div style={{ fontFamily: "Cormorant Garamond", fontSize: "20px", color: "#0A0A0A", fontWeight: 400 }}>{a.name}</div>
                      <span style={{ background: sc.bg, border: `1px solid ${sc.border}`, color: sc.color, fontFamily: "Manrope", fontSize: "11px", fontWeight: 700, padding: "3px 10px", borderRadius: "12px" }}>{sc.label}</span>
                    </div>
                    <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                      <span style={{ fontFamily: "Manrope", fontSize: "13px", color: "#6b7280", display: "flex", alignItems: "center", gap: "4px" }}><Phone size={12} />{a.phone}</span>
                      {a.city && <span style={{ fontFamily: "Manrope", fontSize: "13px", color: "#6b7280" }}>{a.city}</span>}
                      {a.category && <span style={{ fontFamily: "Manrope", fontSize: "13px", color: "#C5A059" }}>{a.category}</span>}
                      {a.date && <span style={{ fontFamily: "Manrope", fontSize: "13px", color: "#6b7280" }}>Дата: {a.date}</span>}
                    </div>
                    {a.comment && <div style={{ fontFamily: "Manrope", fontSize: "12px", color: "#9ca3af", marginTop: "8px", fontStyle: "italic" }}>"{a.comment}"</div>}
                    <div style={{ fontFamily: "Manrope", fontSize: "11px", color: "#aaa", marginTop: "6px" }}>
                      {a.created_at ? new Date(a.created_at).toLocaleString("ru-RU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : ""}
                    </div>
                  </div>
                  {/* Actions */}
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {a.status === "pending" && (
                      <>
                        <button data-testid={`confirm-appt-${a.id}`} onClick={() => updateStatus(a.id, "confirmed")}
                          style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "6px", padding: "8px 14px", cursor: "pointer", fontFamily: "Manrope", fontSize: "12px", fontWeight: 600, color: "#16a34a", display: "flex", alignItems: "center", gap: "6px" }}>
                          <Check size={14} />Подтвердить
                        </button>
                        <button onClick={() => updateStatus(a.id, "cancelled")}
                          style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "6px", padding: "8px 14px", cursor: "pointer", fontFamily: "Manrope", fontSize: "12px", fontWeight: 600, color: "#dc2626", display: "flex", alignItems: "center", gap: "6px" }}>
                          <X size={14} />Отменить
                        </button>
                      </>
                    )}
                    {a.status === "confirmed" && (
                      <button onClick={() => updateStatus(a.id, "done")}
                        style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", padding: "8px 14px", cursor: "pointer", fontFamily: "Manrope", fontSize: "12px", fontWeight: 600, color: "#374151", display: "flex", alignItems: "center", gap: "6px" }}>
                        <Clock size={14} />Выполнено
                      </button>
                    )}
                    <a href={`https://wa.me/${a.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer"
                      style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "6px", padding: "8px 14px", textDecoration: "none", fontFamily: "Manrope", fontSize: "12px", fontWeight: 600, color: "#16a34a" }}>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
